"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const _service_1 = require("~service");
const styled_1 = require("./styled");
const EnterpriseQuoteForm = ({ token, setQuote }) => {
    const useMutationResult = _service_1.productQuoteService.useGetQuote({});
    const initialValues = {
        accessCode: '',
    };
    return ((0, jsx_runtime_1.jsxs)(styled_1.StyledFormWrapper, { children: [(0, jsx_runtime_1.jsx)(styled_1.StyledIntro, { children: "Enter your authentiction code to access your quote." }), (0, jsx_runtime_1.jsx)(ui_1.Formik, { initialValues: initialValues, onSubmit: (values) => __awaiter(void 0, void 0, void 0, function* () {
                    const quote = yield useMutationResult.mutateAsync({
                        token,
                        accessCode: values.accessCode,
                    });
                    setQuote(Object.assign(Object.assign({}, quote), { accessCode: values.accessCode }));
                }), children: (props) => ((0, jsx_runtime_1.jsx)(ui_1.Form, { submitText: "Submit", submitTheme: "upgrade", useMutationResult: useMutationResult, formikProps: props, children: (0, jsx_runtime_1.jsx)(ui_1.Field, { name: "accessCode", type: "code", validation: "isNonEmptyString", validationMessage: "Required", formikProps: props }) })) })] }));
};
exports.default = EnterpriseQuoteForm;
